<template>
    <div class="wrapper row">
        <div class="crm-scroll-hover" id="grid-template" v-on:scroll="scrl" :class="{vhminus200:page=='activity',vhminus200Organization:page=='organization'}">
            <div class="table-body-wrapper">
                <table class="table-body gridTable">
                    <thead class="gridHead">
                        <tr>
                            <th class="checkboxCol" v-if="
                            (page=='opportunities'&&($can('can_bulk_delete_deals')||$can('can_bulk_update_deals')))||
                            (page=='activity'&&$can('can_bulk_delete_activities'))||
                            (page=='organization'&&$can('can_bulk_delete_organizations'))||
                            (page=='contact'&&$can('can_bulk_delete_contacts'))||
                            (page=='product'&&$can('can_bulk_delete_products')) 
                            ">
                                <input type="checkbox" v-model="checkAllRows">
                            </th>
                            <template v-if="(page !=='workflowManagement' && page !=='forms' && page !=='process' && page !=='adminProcess')">
                                <th v-for="(key,index) in columns" v-bind:key="index" v-show="check(key['prop'])"
                                    v-on="key['isSort']!=false  ? { click: () => sortBy(key['prop']) } : {click: ($event) => $event.preventDefault() }"
                                    :class="key['type']"
                                    class="sortable-header"
                                >
                                    <div class="d-flex align-items-center">
                                        <span>{{ capitalize(key['name']) }}</span>
                                        <div class="arrowSort" v-if="key['isSort']!=false">
                                            <i class="fa fa-sort-up" :class="(sortKey == key['prop'] && sortOrders[key['prop']]=='-1') ? 'active-sort-type':''"></i>
                                            <i class="fa fa-sort-down" :class="(sortKey == key['prop'] && sortOrders[key['prop']]=='1') ? 'active-sort-type':''"></i>
                                        </div>
                                    </div>
                                </th>
                            </template>
                            <template v-if="(page ==='workflowManagement' || page ==='forms' || page ==='process' || page ==='adminProcess')">
                                <th v-for="(key,index) in columns" v-bind:key="index" v-show="check(key['prop'])"
                                >
                                    <div class="d-flex align-items-center">
                                        <span>{{ capitalize(key['name']) }}</span>
                                    </div>
                                </th>
                            </template>
                            <th>
                                
                            </th>
                        </tr>
                    </thead>
                    <tbody class="">
                        
                        <tr v-for="(entry,index) in filteredData" :key="index" v-bind:class="{passive:isPassiveOrg(entry)||isProductPassive(entry),trBgColor:trColor(index)}">
                            
                            <td class="checkboxCol p-1" style="opacity:1" 
                            v-if="
                            (page=='opportunities'&&($can('can_bulk_delete_deals')||$can('can_bulk_update_deals')))||
                            (page=='activity'&&$can('can_bulk_delete_activities'))||
                            (page=='organization'&&$can('can_bulk_delete_organizations'))||
                            (page=='contact'&&$can('can_bulk_delete_contacts'))||
                            (page=='product'&&$can('can_bulk_delete_products'))
                            ">
                                <input type="checkbox" v-model="checkedRows" :disabled="checkAllRows" :value="entry['_id']['val']['$oid']">
                            </td>
                            <template v-for="col in columns" :key="col.prop">
                            <td v-if="col['viewTable']==undefined || col['viewTable']==true" v-show="check(col['prop'])" class="spanWrapper" v-bind:class="entry[col['prop']]['type']"
                              v-on:dblclick="entry[col['prop']]['type']==='isDone'?entry[col['prop']]['isEditMode']=true:''"
                               >
                               
                               <span v-if="entry[col['prop']]['type']==='orgName'" >
                                    <span v-show="!entry[col['prop']]['isEditMode']"
                                    v-tooltip="entry[col['prop']]['val']"
                                    class="hover-color-primary" @click="(blockedList.includes(col['prop'])||isPassiveOrg(entry))?'':organizationCard(entry['_id']['val']['$oid'])"
                                    > {{entry[col['prop']]['val']}}</span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='orgStatus'" >
                                    <span v-if="entry[col['prop']]['val']"> 
                                        {{$ml.get('ACTIVE')}}
                                    </span>
                                    <span v-else>
                                        {{$ml.get('PASSIVE')}}
                                    </span>
                                    
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='contactName'" >
                                    <span  v-show="!entry[col['prop']]['isEditMode']" class="hover-color-primary" @click="contactCard(entry['_id']['val']['$oid'])">  {{entry[col['prop']]['val']}}</span>
                                    
                                </span>
                                
                                
                                <span v-else-if="entry[col['prop']]['type']==='contacts'" >
                                    {{fullname(entry[col['prop']]['val']['0'])}}
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='friendlyName'" >
                                    <span v-if="entry[col['prop']]['val']!==null"
                                          v-tooltip="entry[col['prop']]['val']"
                                          class="hover-color-primary">
                                       {{truncate(entry[col['prop']]['val'], 12)}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='user'" v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="entry[col['prop']]['val']!==undefined&&entry[col['prop']]['val']['$oid']!==''&&users.find(usr => usr._id['$oid']==entry[col['prop']]['val']['$oid'])!=undefined">
                                            {{users.find(usr => usr._id['$oid']==entry[col['prop']]['val']['$oid']).name}}
                                            {{users.find(usr => usr._id['$oid']==entry[col['prop']]['val']['$oid']).surName}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='status'" >
                                    
                                    <span v-if="entry[col['prop']]['val'] === true">True</span>
                                    
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='module'" >
                                    
                                    <span v-if="entry[col['prop']]['val'] === 'deals'">{{$ml.get('OPPORTUNITIES')}}</span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'organizations'">{{$ml.get('COMPAINES')}}</span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'activities'">{{$ml.get('ACTIVITIES')}}</span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'contacts'">{{$ml.get('PERSONS')}}</span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'products'">{{$ml.get('PRODUCTS')}}</span>
                                    
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='triggeredOn'" >
                                    
                                    <span v-if="entry[col['prop']]['val'] === 'create'"
                                        v-tooltip="$ml.get('ON_RECORD_CREATION')"
                                          class="hover-color-primary">
                                        {{truncate($ml.get('ON_RECORD_CREATION'), 16)}}
                                    </span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'update'"
                                        v-tooltip="$ml.get('ON_RECORD_UPDATE')"
                                          class="hover-color-primary">
                                        {{truncate($ml.get('ON_RECORD_UPDATE'), 16)}}
                                    </span>
                                    <span v-else-if="entry[col['prop']]['val'] === 'always'"
                                          v-tooltip="$ml.get('ON_RECORD_CREATION_OR_UPDATE')"
                                          class="hover-color-primary">
                                        {{truncate($ml.get('ON_RECORD_CREATION_OR_UPDATE'), 16)}}
                                    </span>
                                    
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='date_updated'" >
                                    <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val']['$date']!==''">
                                       {{formatDate(new Date(entry[col['prop']]['val']['$date']), "DD/MM/YYYY")}}
                                       <!-- {{Math.max(entry[col['prop']]['val']['$date'])}} -->
                                    </span>
                                    
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='contactDetail'" >
                                    <span  v-show="!entry[col['prop']]['isEditMode']" v-if="entry[col['prop']]['val']!=null" class="hover-color-primary" @click="contactCard(entry[col['prop']]['val']['_id']['$oid'])">  {{entry[col['prop']]['val']['n']}} {{entry[col['prop']]['val']['sn']}}</span>
                                  
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='dealsName'" >
                                    <span  v-show="!entry[col['prop']]['isEditMode']" v-tooltip="entry[col['prop']]['val']" class="hover-color-primary" @click="dealsCard(entry['_id']['val']['$oid'])">  {{entry[col['prop']]['val']}}</span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='price'" >
                                    <template v-for="(price,index) in entry[col['prop']]['val']" :key="index">
                                        <span v-show="!entry[col['prop']]['isEditMode']" v-if="price['price']!==null"> {{formatPrice(price['price'])}} {{currencySymbol(price['currency'])}} <b v-if="index!=entry[col['prop']]['val'].length-1">, </b></span>
                                    </template>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='value'" class="value">
                                    {{currencySymbol(entry['currency']['val'])}}  {{entry[col['prop']]['val']}}
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='currency'" >
                                    {{currencySymbol(entry[col['prop']]['val'])}}
                                </span>
                                 <span v-else-if="entry[col['prop']]['type']==='candidate'" >
                                     {{candidateStatus(entry[col['prop']]['val'])}}
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='country'" >
                                     <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val'] !==undefined ">
                                     {{entry[col['prop']]['val']}}

                                     </span>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='city'" >
                                     <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val'] !==undefined  && entry[col['prop']]['val'] !=='' ">
                                         {{entry[col['prop']]['val']}}
                                     </span>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='town'" >

                                     <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val'] !==undefined ">
                                         <span>
                                             {{entry[col['prop']]['val']}}
                                         </span>
                                     </span>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='contact'" >
                                     <span v-for="(contact, cIdx) in entry[col['prop']]['val']" :key="cIdx" v-show="!entry[col['prop']]['isEditMode']">
                                         ( {{nicename(entry[col['prop']]['val'])}} )
                                     </span>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='relContact'" >
                                     <span  v-show="!entry[col['prop']]['isEditMode']" v-if="entry[col['prop']]['val']!=null" class="hover-color-primary" @click="contactCard(entry[col['prop']]['val']['0']['_id']['$oid'])">  {{nicename(entry[col['prop']]['val'])}} </span>
                                 </span>

                                 <span v-else-if="entry[col['prop']]['type']==='deals'" >
                                     <template v-for="(deal, dIdx) in entry[col['prop']]['val']" :key="dIdx">
                                         <span v-show="!entry[col['prop']]['isEditMode']" v-if="deal['title']!==null">{{deal['status']==1?`(${deal['title']})`:''}} </span>
                                     </template>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='dealStatus'" class="w-100">
                                     <span class="dealsStatus-btn w-100" v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val']!==undefined">
                                         <b v-if="entry[col['prop']]['val']==1" class="open-btn" style="background-color:#E9EDF5; color:#5A6376; border-radius:4px; border:0;">{{$ml.get('OPEN')}}</b>
                                         <b v-if="entry[col['prop']]['val']==2" class="win-btn" style="background-color:#E1FCEF; border-radius:4px; border:0;">{{$ml.get('WON')}}</b>
                                         <b v-if="entry[col['prop']]['val']==3" class="notwin-btn" style="background-color:#FFEDEF; border-radius:4px; border:0;">{{$ml.get('NOT_WON')}}</b>
                                      </span>
                                 </span>
                                 <span v-else-if="entry[col['prop']]['type']==='organizations'" >
                                     <template v-for="(organization, oIdx) in entry[col['prop']]['val']" :key="oIdx">
                                         <span v-if="organization!=null" v-tooltip="organization['name']" class="hover-color-primary" v-show="!entry[col['prop']]['isEditMode']" @click="(blockedList.includes(col['prop'])||isPassiveOrg(entry))?'':organizationCard(organization._id.$oid)">
                                            {{organization['name']}}
                                         </span>
                                     </template>
                                 </span>
                                <span v-else-if="entry[col['prop']]['type']==='step'" >
                                    <span>
                                        {{getStep(entry[col['prop']]['val'], $ml)}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='activityType'" >
                                    {{activityType(entry[col['prop']]['val'], $ml)}}
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='dealsOrgName' || entry[col['prop']]['type']===8 " >
                                    <span 
                                        v-if="entry[col['prop']]['val']!=undefined && entry[col['prop']]['val']!=null"
                                        @click="(blockedList.includes(col['prop'])||isPassiveOrg(entry))?'':organizationCard(entry[col['prop']]['val']._id.$oid)"
                                        v-tooltip="entry[col['prop']]['val']['name']"
                                        class="hover-color-primary" >
                                        {{entry[col['prop']]['val']['name']}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='phones' || entry[col['prop']]['type']==='emailAddresses'" >
                                    <span v-if="entry[col['prop']]['val']">{{handleArray(entry[col['prop']]['val'])}}</span>
                                </span>
                                <!-- Date Objects  -->
                                <span v-else-if="entry[col['prop']]['type']==='dateObj'" >
                                    <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val']['$date']!==''">
                                       {{formatDate(new Date(entry[col['prop']]['val']['$date']), "DD/MM/YYYY")}}
                                    </span>
                                    
                                </span>
                                
                                <span v-else-if="entry[col['prop']]['type']==='duration'" >
                                    {{entry[col['prop']]['val']}}
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='formObj'" >
                                    <span v-if="entry[col['prop']]['val'] != null">
                                        {{entry[col['prop']]['val']['name']}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='stepObj'" >
                                    {{entry[col['prop']]['val']['name']}}
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='rate'" class="d-inline-block" >
                                    <span v-if="entry[col['prop']]['val']!==null">
                                        <img src="~/../assets/rate-normal.png" v-if="entry[col['prop']]['val']==1" v-tooltip="getRates(entry[col['prop']]['val'])"/>
                                        <img src="~/../assets/rate-oncelikli.png" v-if="entry[col['prop']]['val']==2" v-tooltip="getRates(entry[col['prop']]['val'])"/>
                                        <img src="~/../assets/rate-acil.png" v-if="entry[col['prop']]['val']==3" v-tooltip="getRates(entry[col['prop']]['val'])"/>
                                     </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']==='isDone'">
                                    <span v-if="entry[col['prop']]['val']==true">
                                        {{$ml.get('COMPLETED')}}
                                    </span>
                                    <span v-else>
                                        {{$ml.get('OPEN')}}
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']===3" v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="entry[col['prop']]['val']"> <!--Burası normal gelenler-->
                                        {{formatDate(entry[col['prop']]['val'].$date, "DD/MM/YYYY")}}
                                    </span>
                                </span>
                                
                                <span v-else-if="entry[col['prop']]['type']===4" v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="entry[col['prop']]['val'].name"> <!--Burası normal gelenler-->
                                        {{entry[col['prop']]['val'].name}}
                                        {{entry[col['prop']]['val'].surName}}
                                    </span>
                                    <span v-else-if="entry[col['prop']]['val'].$oid!=''&&entry[col['prop']]['val'].$oid!=undefined"><!--Burası filtre ile gelenler-->
                                        <span v-if="col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid)!=undefined">{{col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid).name}}</span>
                                        <span v-if="col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid)!=undefined">{{col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid).surName}}</span>
                                    </span>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']===5 && entry[col['prop']]['val']" v-show="!entry[col['prop']]['isEditMode']">
                                    {{formatPrice(entry[col['prop']]['val'])}} {{currencySymbol(entry[col['prop']]['val']['currency'])}}
                                </span>
                                
                                <span v-else-if="entry[col['prop']]['type']===6" >
                                    <span v-if="entry[col['prop']]['val']!==''&&col['options'].find(opt => opt.id==entry[col['prop']]['val'])!==undefined">({{col['options'].find(opt => opt.id==entry[col['prop']]['val']).label}})</span> 
                                </span>
                                <span v-else-if="entry[col['prop']]['type']===7">
                                    <template v-for="(option, optIdx) in entry[col['prop']]['val']" :key="optIdx">
                                        <span v-if="col['options'].find(opt => opt.id==option)!==undefined" >({{col['options'].find(opt => opt.id==option).label}})</span>
                                    </template>
                                </span>
                                <span v-else-if="entry[col['prop']]['type']===9" v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="entry[col['prop']]['val']!=null" class="hover-color-primary" @click="contactCard(entry[col['prop']]['val']._id.$oid)">
                                        {{entry[col['prop']]['val'].n}}
                                        {{entry[col['prop']]['val'].sn}}
                                    </span>
                                </span>
                                <span v-else v-show="!entry[col['prop']]['isEditMode']" :class="entry[col['prop']]['type']">{{entry[col['prop']]['val']}} </span>
                            </td>
                            </template>
                            <td class="text-center tableToggleButon">
                                <i class="fa fa-ellipsis-v px-2 " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                v-if="(page=='product'&&(((ownerId==entry['cuid']['val']['$oid']&&$can('can_edit_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_edit_other_users_products')))||((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_products')))))"></i>

                                <i class="fa fa-pencil-square-o h-14" v-else-if="page=='process'" @click="editProcess(entry['_id']['val']['$oid'])"></i>

                                <i class="fa fa-ellipsis-v px-2 " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else-if="page!=='product'"></i>

                                <div class="dropdown-menu dropdown-menu-left p-0 multiChoose">
                                    <ul class="new-dropdown p-0" v-if="page=='activity'">
                                        <li @click="updateCell(entry,'done',true)" v-if="!entry['done']['val']">{{$ml.get('MARK_AS_COMPLETED')}}</li>
                                        <li @click="updateCell(entry,'done',false)" v-else>{{$ml.get('MARK_AS_OPEN')}}</li>
                                        <li data-toggle="modal" data-target="#add" @click="editLine(entry),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']"><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_activities'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_activities')))"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='workflowManagement'">
                                        <li @click="editContact(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']" ><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteWorkflow(index)"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='forms'">
                                        <li @click="editForm(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']" ><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteForm(entry['_id']['val']['$oid'])" ><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    
                                    <ul class="new-dropdown p-0" v-else-if="page=='adminProcess'">
                                        <li @click="editProcess(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']" ><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteProcess(entry['_id']['val']['$oid'])"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='contact'">
                                        <li @click="editContact(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']" ><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_contacts'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_contacts')))"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='organization'">
                                        <li @click="editOrganization(entry['_id']['val']['$oid']),modalMode='Düzenle'" :id="entry['_id']['val']['$oid']"><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_organizations'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_organizations')))"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='product'">
                                        <li data-toggle="modal" data-target="#add" @click="editLine(entry),modalMode='Düzenle'" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_edit_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_edit_other_users_products')))" :id="entry['_id']['val']['$oid']"><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_products'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_products')))"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                    <ul class="new-dropdown p-0" v-else-if="page=='opportunities'">
                                        <li @click="dealsCard(entry['_id']['val']['$oid'])" ><i class="fa fa-pencil-square-o h-14" ></i> {{$ml.get('UPDATE')}}</li>
                                        <li class="text-danger" @click="deleteThis(entry,page,index)" v-if="((ownerId==entry['cuid']['val']['$oid']&&$can('can_delete_deals'))||(ownerId!=entry['cuid']['val']['$oid']&&$can('can_delete_other_users_deals')))"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
                
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { mapGetters} from 'vuex'
import axios from 'axios'
import _ from 'underscore'
import { Settings } from 'luxon'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'
import { activityType, nicename } from '@/services/resultTableFormatters'
import { handleArray, formatPrice, getStep, capitalize, fullname, truncate } from '@/services/gridFormatters'
export default {
    name: "grid",
    components:{
        CountrySelect,
        RegionSelect
    },
    /*
    props: {
        data: Array,
        columns: Array,
        cellUpdateUrl:String,
        filterGuide:String,
        page:String,
        user:Array
    },
    */
    props:["data","tableConfigVisible","columns","cellUpdateUrl","filterGuide","page","user","users","permissions"],
    data(){
        return {
            searchQuery: '',
            firstLetter:'',
            sortKey: '',
            sortOrders: {},
            editMode:false,
            checkedx:true,
            selectContact:'',
            selectOrganization:'',
            contactKeyword:'',
            dealKeyword:'',
            organizationKeyword:'',
            isHiddenOrganization:false,
            isHiddenContact:false,
            isHiddenDeal:false,
            items:[],
            contactId:"",
            dealId:"",
            organizationId:"",
            entrx:{},
            contactArray:[],
            keyList:['subject','name','n','sn'],
            countryList:[],
            checkedRows:[],
            checkAllRows:false
        }
    },
    computed: {
        ...mapState([
            'activityTypeList',
            'baseUrl',
            'isDoneList',
            'candidateList',
            'durationList',
            'cityList',
            'townList',
            'blockedList',
            'updateCellStatus'
        ]),
        ...mapGetters(['ownerId','userName']),
        returnUpdateCell() {
             return this.$store.state.updateCellStatus
        },
        filteredData: function () {
            let sortKey = this.sortKey;// name
            let filterByLetter = this.firstLetter && this.firstLetter.toLowerCase();
            let order = this.sortOrders[sortKey] || 1;
            
            let data = this.data;
            let guideCol = this.filterGuide
            
            if(this.page=='activity'){
                
                let todaysActivities = 0
                const isToday = (someDate) => {
                    
                    
                    const theDay = new Date(someDate)
                    const today = new Date()
                    
                    return (theDay.toDateString() === today.toDateString())
                }
                for(var row in data){
                    for( var col in data[row]){
                        if(data[row][col]['val']!==null){
                            
                        
                            if(data[row]['done']['val']==false&&col=='dueDate'&&isToday(data[row][col]['val']['$date'])){
                                
                                todaysActivities=todaysActivities+1
                            }
                        }
                        
                    }
                }
                if(todaysActivities>0){
                    if(localStorage.loginCookie=="true"){
                        swal(this.activityMesaage(todaysActivities))
                    }
                    localStorage.loginCookie=!localStorage.loginCookie
                }
            }
            
            return data;
        }
    },
    methods: {
        activityType,
        nicename,
        handleArray,
        formatPrice,
        getStep,
        capitalize,
        fullname,
        truncate,
        formatDate(value, format){
            return this.$moment(value).format(format)
        },
        deleteWorkflow(index){
            this.$emit('deleteWorkflowSection', index)
        },
        activateRootModal(refName, methodName){
            this.$nextTick(() => {
                const modal = this.$root && this.$root.$refs && this.$root.$refs[refName]
                if (modal && typeof modal[methodName] === 'function') {
                    modal[methodName]()
                }
            })
        },
        editOrganization(orgId){
            if(orgId!==null&&orgId!==undefined&&orgId!==''){
                this.$emit('editOrganization',orgId)
            }
            this.activateRootModal('newOrganization', 'activaTabOrganization')
        },
        editContact(contactId){
            if(contactId!==null&&contactId!==undefined&&contactId!==''){
                this.$emit('editContact',contactId)
            }
            this.activateRootModal('newContact', 'activaTabContact')
        },
        editForm(formId){
            if(formId!==null&&formId!==undefined&&formId!==''){
                this.$emit('editForm',formId)
            }
        },
        deleteForm(formId){
            this.$emit('deleteForm', formId)
        },
        editProcess(processId){
            if(processId!==null&&processId!==undefined&&processId!==''){
                this.$emit('editProcess',processId)
            }
        },
        deleteProcess(processId){
            if(processId!==null&&processId!==undefined&&processId!==''){
                this.$emit('deleteProcess',processId)
            }
        },
        activityMesaage(count){
            if(localStorage.getItem('vueml-lang')=='tr'){
                var message="Bugün yapmanız gereken "+count+" aktivite var"
            }else{
                var message="You have "+count+" activity(ies) for today  "
            }
            return message
        },
        countryListSave(country,index){
            this.countryList[index]=country
        },
        getRates(rate){
            var rates={ 1:this.$ml.get('NORMAL'),2:this.$ml.get('PRIORITY'),3:this.$ml.get('URGENT') }
            return rates[rate]
        },
        getPriceVal(price){
            var prAray = []
            var prObj = {}
            prObj['price']=price['price']
            prObj['currency']=price['currency']
            prAray.push(prObj)
            return prAray
        },
        organizationCard(id){
            if(id!==""&&id!=null){
                //localStorage.orgId=id
                //this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        dealsCard(id){
            if(id!==""){
                localStorage.dealId=id
                this.updateDealId(id)
                window.open('/dealCard/'+id, '_blank');
            }
        },
        ...mapActions([
            'updateCella',
            'updateOrgId',
            'updateContactId',
            'updateDealId',
            //'currencySymbol'
        ]),
        isPassiveOrg:function(entry){
            if(entry['status']==undefined || !entry['status']){
                return false
            }else{
                if(entry['status']['type']=='orgStatus'&&entry['status']['val']!=true){
                    return true
                }
            }
        
    
            
        },
        isProductPassive(entry){
            if(this.page=="product"){
                if(entry.status.val==null){
                    return false
                }else{
                    if(entry.status.val==true){
                        return false
                    }else{
                        return true
                    }
                }
            }
        },
        scrl: function(){
            const element= document.getElementById('grid-template')
            const scrollYEmit = element.scrollTop + 10
            const clientHeightEmit = element.clientHeight
            const scrollHeightEmit = element.scrollHeight
            var previousScrollPosition = clientHeightEmit 
            var currentScrollPosition = scrollYEmit + clientHeightEmit 
            if (currentScrollPosition>previousScrollPosition) {
                this.$emit('scrolled',scrollYEmit,clientHeightEmit,scrollHeightEmit)
            }
            
        },
        sortBy: function (key) {
            this.sortKey = key;
            if(this.sortOrders[key]==null){
                this.sortOrders[key]=1
            }
            this.sortOrders[key] = this.sortOrders[key] * -1
            var form={}
            form['sort']=this.sortKey 
            form['sortType']=this.sortOrders[key]
            this.$emit('sortedData',form)
        },
        candidateStatus: function (is) {
            
            if(is!==null){
                return is===true ? this.$ml.get('LEAD') : this.$ml.get('CUSTOMER')
            }else{
                return this.$ml.get('CUSTOMER')
            }
            
        },
        check:function(col){
            var cols = this.tableConfigVisible
            return cols.includes(col) && col!='_id' && col!='notes' && col!='x'
        },
        updateCell:function(model,col,val){
            let payload = {'model': model, 'col': col, 'val':val, 'url':this.cellUpdateUrl}
            this.$store.dispatch('updateCella', payload)
        },
        editLine(data){
            this.$store.dispatch('editLine', data)
            let statu=true
            this.$store.dispatch('editLineStatu', statu)

            // The modal data is store-driven.  The root reference can briefly be
            // unavailable while Vue 3 is mounting/replacing a route component, so
            // activate the tab only when its modal component is present.
            this.$nextTick(() => {
                if (window.location.pathname === "/activities") {
                    const activityModal = this.$root && this.$root.$refs && this.$root.$refs.newActivities
                    if (activityModal && typeof activityModal.activaTab === 'function') {
                        activityModal.activaTab()
                    }
                }
                if (window.location.pathname === "/products") {
                    const productModal = this.$root && this.$root.$refs && this.$root.$refs.newProduct
                    if (productModal && typeof productModal.activaTabProduct === 'function') {
                        productModal.activaTabProduct()
                    }
                }
            })
        },
        routerRequest(field,entry){
            this.entrx=entry
            
            if(field==="contact"){
                
                var orgId=''
                if(entry['orgId']['val'].length!==0){
                    
                    orgId=entry['orgId']['val'][0]['_id']['$oid']
                }
                if(this.selectContact!==this.contactKeyword){
                    this.quickContact(orgId) 
                    this.isHiddenOrganization=false
                    this.isHiddenDeal=false 
                }
                if(this.contactKeyword===""){
                    this.quickContact(orgId) 
                }
            }
            if(field==="organization"){
                
                if(this.selectOrganization!==this.organizationKeyword){
                    this.quickOrganization()
                    this.isHiddenContact=false
                    this.isHiddenDeal=false 
                }
                if(this.organizationKeyword===""){
                    this.quickOrganization() 
                }
            }
            if(field==="deal"){
                var contactId = '' 
                var orgId = ''
                if(entry['contactId']['val'].length!==0){
                    
                    contactId=entry['contactId']['val'][0]['_id']['$oid']
                } 
                if(entry['orgId']['val'].length!==0){
                    
                    orgId=entry['orgId']['val'][0]['_id']['$oid']
                }
                if(this.selectDeal!==this.dealKeyword){
                    this.quickDeal(contactId,orgId)
                    this.isHiddenOrganization=false
                    this.isHiddenContact=false 
                }
                if(this.dealKeyword===""){
                    this.quickDeal(contactId,orgId) 
                }
            }
        },
        quickDeal(contactId,orgId){
            axios({
                method:'POST',
                url:'/quickFilterDeal',
                baseURL: this.baseUrl,
                data: {
                    dealName:this.dealKeyword,
                    organizationId:orgId,
                    contactId:contactId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.deals
                    this.isHiddenDeal= true
                }
            })
        },
        quickOrganization(){
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    this.isHiddenOrganization= true
                }
            })
        },
        quickContact(orgId){
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: {
                    search:this.contactKeyword,
                    organizationId:orgId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    if(this.items.length>0){
                        this.isHiddenContact= true
                    }
                }
            })
        },
        clear(){
            
            this.selectContact="",
            this.isHiddenOrganization=false,
            this.isHiddenContact=false,
            this.isHiddenDeal=false,
            this.items=[],
            this.contactId=""
        },
        setResult(result,type){
            if(type==="contact"){
                this.contactKeyword=""
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                this.selectContact=result.n
            }
            if(type==="organization"){
                this.organizationKeyword=result.name
                this.isHiddenOrganization= false
                this.organizationId=result._id.$oid
                this.selectOrganization=result.name
            }
            if(type==="deal"){
                this.dealKeyword=result.title
                this.isHiddenDeal = false
                this.dealId=result._id.$oid
                this.selectDeal=result.title
            }
            this.entrx={}
        },
        getTownName(list,index){
            if(list!==undefined){
                return list[index]
            }
        },
        deleteThis(entry,from,index){
            if(from=='product'){
                var url = '/deleteProduct'
                var subj = this.$ml.get('DELETE_PRODUCT')
            }else if(from=='activity'){
                var url = '/deleteActivity'
                var subj = this.$ml.get('DELETE_ACTIVITY')
            }else if(from=='organization'){
                var url = '/deleteOrganization'
                var subj = this.$ml.get('DELETE_COMPANY')
            }else if(from=='contact'){
                var url = '/deleteContact'
                var subj = this.$ml.get('DELETE_CONTACT')
            }else if(from=="opportunities"){
                var url= "/deleteDeal"
                var subj = this.$ml.get('DELETE_DEAL')
            }
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_RECORD_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                    axios({
                        method:'POST',
                        url:url,
                        baseURL: this.baseUrl,
                        data: {
                            objId:entry['_id']['val']['$oid']
                        },
                        withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(!res.data.status){
                            this.$router.push('/logout')
                        }
                        if(res.data.status.code==0){
                            this.filteredData.splice(index, 1)
                            let text = ""
                            if(from=='product'){
                                text=this.$ml.get('PRODUCT_DELETED')
                            }else if(from=='activity'){
                                text=this.$ml.get('ACTİVİTY_DELETED')
                            }else if(from=='organization'){
                                text=this.$ml.get('COMPANY_DELETED')
                            }else if(from=='contact'){
                                text=this.$ml.get('CONTACT_DELETED')
                            }else if(from=='opportunities'){
                                text=this.$ml.get('DEAL_DELETED')
                            }
                            
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: text
                            })
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: res.data.status.desc
                            })
                        }
                    })
                    
                }
            })
        },
        trColor(index){
            if(index%2===0){
                return true
            }else{
                return false
            }
        }
    },
    created(){
        let sortOrders = {};
        this.columns.forEach(function (key) {
        sortOrders[key['prop']] = 1;
        })
        this.sortOrders = sortOrders;
        // console.log("Currency.symbol(1)")
        // console.log(this.currencySymbol(1))
        
    },
    watch: {
        checkAllRows(val){
            if(val){
                for(var entry in this.filteredData){
                    this.checkedRows.push(this.filteredData[entry]['_id']['val']['$oid'])
                }
                this.$emit('updateCheckedRows','allRowsChecked')
            }else{
                this.checkedRows=[]
                this.$emit('updateCheckedRows',this.checkedRows)
            }
        },
        checkedRows(){
            if(!this.checkAllRows){
                this.$emit('updateCheckedRows',this.checkedRows)
            }
        },
        returnUpdateCell(val){
            if(val){
                this.$emit('refleshData') 
            }
        },
        organizationKeyword: _.debounce(function(addr) {
            if(this.selectOrganization!==this.organizationKeyword && this.organizationKeyword.length!==0){
                this.quickOrganization()
                this.isHiddenContact=false
                this.isHiddenDeal=false
            }
            if(this.organizationKeyword===""){
                this.isHiddenOrganization= false
                this.organizationId=""
            } 
        }, 300),
        contactKeyword: _.debounce(function() {
            var entry = this.entrx
            var orgId=''
            if(entry['orgId']['val'].length!==0){
                orgId=entry['orgId']['val'][0]['_id']['$oid']
            }
            if(this.contactKeyword===""){
                this.isHiddenContact= false
                this.contactId=""
            } 
            if(this.selectContact!==this.contactKeyword && this.contactKeyword.length!==0){
                this.quickContact(orgId)
            }
        }, 300),
        dealKeyword: _.debounce(function() {
            var entry=this.entrx
            var contactId = '' 
            var orgId = ''
            if(entry['contactId']['val'].length!==0){
                
                contactId=entry['contactId']['val'][0]['_id']['$oid']
            } 
            if(entry['orgId']['val'].length!==0){
                
                orgId=entry['orgId']['val'][0]['_id']['$oid']
            }
            if(this.dealKeyword===""){
                this.isHiddenDeal=false
            } 
            if(this.selectDeal!==this.dealKeyword && this.dealKeyword.length!==0){
                this.quickDeal(contactId,orgId)
                this.isHiddenOrganization=false
                this.isHiddenContact=false 
            }
        }, 300)
    }
}
</script>
<style scoped>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
    
    .editIcon{
        display:none;
    }
    .tableToggleButon:hover{
        background-color: #E5E5E5;
    }
    #grid-template > .table-body-wrapper {
        width: 100%;
    }
    #grid-template {
        width: 100%;
        overflow-x: auto;
        /* overflow-y: auto; */
        height: calc(100vh - 148px);
    }
    .vhminus200{
        height: calc(100vh - 181px)!important;
    }
    .vhminus200Organization{
        height: calc(100vh - 181px)!important;
    }
    #grid-template > .table-body-wrapper {
        flex: 1;
    }
    body{
        font-family: Helvetica Neue, Arial, sans-serif;
        font-size: 14px;
        color: #555;
    }
    table {
        border-spacing: 0;
        width: 100%;
    }
    th.checkboxCol,td.checkboxCol{
        width: 30px!important;
        min-width: 30px!important;
    }
    th.active {
        font-weight: bolder;
    }
    #grid-template {
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        width: 100%;
        border: .5px solid #AFC2D9;
        border-radius: 4px;
    }
    .check-scroll{
        overflow-y: scroll;
        height: 90px;
    }
    .max-width-35{
        max-width: 35%!important;
    }
    .gridTable input{
        border: 0px;
        width: 100%;
    }
    .gridTable {
        border-spacing: 0;
        width: 100%;
    }
    
    .gridTable tbody tr {
        background-color: #FCFDFF;
        border-bottom: 0.5px solid rgba(175, 194, 217, 0.5);
        cursor: pointer;
        color: #333333;
    }
    .gridTable tbody tr select{
        color: #53565E;
    }
    .gridTable thead th span{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
    }
    .gridTable thead th {
        padding-left: 6px;
        font-size: 12px;
        color: #474747;
        padding: 0 8px;
        height: 45px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1;
        background: #f0f1f3;
        box-shadow: 0px 1px 0px 0px #AFC2D9;
    }
    .gridTable th:last-child {
        font-size: 12px;
        min-width: 45px!important;
    }
    .gridTable tbody tr td {
        height: 45px;
        font-size: 14px;
        padding: 0 8px;
        transition: 0.3s all;
    }
    .gridTable tbody tr td:first-child {
        opacity: 0;   
        -webkit-transition: 0.3s all;
        transition: 0.3s all;
        font-size: 17px;
        color: #1891eb;
        padding: 0;
        text-align: center;
    }
    .gridTable tbody tr td:last-child{
        opacity: 0;
        -webkit-transition: 0.3s all;
        transition: 0.3s all;
    }
    .gridTable tbody tr:not(.passive):hover {
        /* box-shadow: inset 0px 0.2px 0px 0.2px #1991EB; */
        background-color: #F7F9FC;
        /* HOVER */
    }
    .gridTable tbody tr:hover td:first-child,.gridTable tbody tr:hover td:last-child {
        opacity: 1;
    }
    .gridTable label{
        cursor: pointer;
        color: #666;
        padding: 0px;
        margin: 0px;
    }
    .gridTable input[type="checkbox"]:disabled + .label-text:before{
        content: "\f0c8";
        color: #ccc;
    }
    @keyframes effect{
        0%{transform: scale(0);}
        25%{transform: scale(1.3);}
        75%{transform: scale(1.4);}
        100%{transform: scale(1);}
    }
    .form-check{
        padding-left: 0.55rem!important;
    }
    .gridColumnFilter{
        list-style: none;
        padding: 10px;
        overflow-y: scroll;
        height: 320px;
    }
    .alphabetic-filter{
        padding-bottom:10px;
    }
    .alphabetic-filter button:first-child {
        width: auto;
        font-family: "font-family-regular";
    }
    .autocomplete {
        position: relative;
        width: 130px;
    }
    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #66D0FF80;
        height: 120px;
        overflow: auto;
        position: fixed;
        z-index: 9999;
        width: 44%;
        background-color: white;
        border-radius: 20px;
        height: auto;
    }
    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 8px 15px;
        cursor: pointer;
    }
    .autocomplete-result:hover {
        background-color: #4AAE9B;
        color: white;
    }
    .isBlocked{
        cursor: not-allowed;
    }
    .iptal:before{
        color:#f76a6a;  
    }
    .gridTable tbody tr.trBgColor{
        background-color:#FFF;
    }
    .dealsStatus-btn b{
        border-radius: 3px;
        border: 1px solid;
        width: 100%;
        text-align: center;
        display: block;
        font-size:10px;
        padding:4px 6px;
        text-transform: uppercase;
    }
    .dealsStatus-btn .open-btn{
        border-color: #F28100;
        color: #F28100;
    }
    .dealsStatus-btn .win-btn{
        border-color: #36AF47;
        color: #36AF47;
    }
    .dealsStatus-btn .notwin-btn{
        border-color: #EF4248;
        color: #EF4248;
    }
    .arrowSort {
        height: 15px;
        width: 5px;
        margin-left: 6px;
    }
    .arrowSort i:first-child {
        position: absolute;
    }
    .gridTable tbody tr.passive{
        color: #A5A7AC;
    }
    .gridTable tbody tr.passive select{
        color: #FFF;
    }
    .sortable-header{
        cursor: pointer;
    }
    .arrowSort>i{
        opacity:0.5;
    }
    .arrowSort>i.active-sort-type{
        opacity:1;
    }
    
</style>
